Aedu.Behaviors.ScrollScope = function () {
  var enabled;
  enabled = false;
  return {
    enable: function ($el) {
      if (!enabled) {
        $(document).scrollScope();
      }
      enabled = true;
      return $el.attr('data-scroll-scope', true);
    }
  };
}();